/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox"
import {SelectedSensorsTable} from "./SelectedSensorsTable"
import {LineActions} from "./LineActions"
import {AnalysisResultsPlot} from "./AnalysisResultsPlot"
import { useAppSelector } from "../../../../../../redux/hooks"
import { selectCurrentStudyId, selectStudy } from "../../../../../../redux/ducks/SensingSystemArchitectureDesign"


/**
 * Sensing System Component Analysis shows a table of the selected sensors, green
 * line actions, and a plot for the current experiment
 */
export const SensingSystemComponentAnalysisSection = () => {
  const studyId = useAppSelector(selectCurrentStudyId)
  const study = useAppSelector(state => selectStudy(state, studyId ?? ''))
  return (
    <ArgosFlexbox vertical style={{padding: '20px', width: '100%', maxHeight: '100%', overflow: 'auto'}}>
      <ArgosFlexbox noGap vertical style={{overflow: 'auto', height: 800}}>
      {!study?.archive && <LineActions/>}
        <ArgosFlexbox noGap style={{overflow: 'auto', height: '100%'}}>
          <SelectedSensorsTable/>
        </ArgosFlexbox>
      </ArgosFlexbox>

      <ArgosFlexbox noGap style={{height: 800, overflow: 'auto', width: '70%'}}>
        <AnalysisResultsPlot/>
      </ArgosFlexbox>
    </ArgosFlexbox>
  )
}
